<template>
  <BaseChip
    class="base-opportunity-tag"
    size="sm"
    tone="neutral"
    preset="soft"
    :icon="icon || 'bullseye-arrow'"
    v-tooltip="{ content: tooltipText, placement: tooltipPlacement }"
    @click="onOpportunityClick"
  >
    <TextHighlight :content="opportunity.name" isPlain></TextHighlight>
  </BaseChip>
</template>

<script>
import BaseChip from '@/components/base/BaseChip.vue';
import TextHighlight from '@/components/text-highlight/TextHighlight';

export default {
  name: 'BaseOpportunityTag',
  components: {
    BaseChip,
    TextHighlight,
  },
  props: {
    opportunity: {
      type: Object,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    tooltipText: {
      type: String,
      required: false,
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top',
    },
  },
  methods: {
    onOpportunityClick() {
      this.$emit('onOpportunityClick', this.opportunity);
    },
  },
};
</script>

<style lang="scss" scoped>
.base-opportunity-tag {
  max-width: 120px;
}
</style>
